<rask-fieldset-toggle
    [formGroup]="form"
    label="Valbara mottagningsplatser"
    [defaultExpanded]="open"
    [nrOfSelectedFilters]="filterLength">
    <rask-multi-selector
        label="Valbara mottagningsplatser"
        bindValue="key"
        bindLabel="value"
        class="w-100"
        [items]="items"
        formControlName="valbaramottagningsplatser"
        [selected]="control.value"
        [portalToBody]="true"
        [searchFn]=keyValueSearchFn>
    </rask-multi-selector>
</rask-fieldset-toggle>